import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import { getAggregateSaleData } from '@/service/purchase/reportAggregate';
export default function useGuliaoSaleData(params) {
  var aggregateSaleData = ref({
    totMoneyList: [],
    settleValueList: [],
    totalSettleValue: 0,
    totalMoney: 0,
    totalAveragePrice: 0,
    totalSingular: 0,
    timeRange: '',
    rawMaterialMoney: 0,
    totalFreight: 0
  });
  // 获取主机汇总数据
  var getAggregateSaleDataAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _data$settleValueList, _data$settleValueList2;
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAggregateSaleData(params.value);
          case 2:
            data = _context.sent;
            aggregateSaleData.value = data;
            return _context.abrupt("return", {
              text: (_data$settleValueList = data.settleValueList[0]) === null || _data$settleValueList === void 0 ? void 0 : _data$settleValueList.name,
              value: (_data$settleValueList2 = data.settleValueList[0]) === null || _data$settleValueList2 === void 0 ? void 0 : _data$settleValueList2.supplier_no
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getAggregateSaleDataAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var summaryData = computed(function () {
    return [{
      num: aggregateSaleData.value.totalSettleValue,
      desc: '总进料量/吨'
    }, {
      num: aggregateSaleData.value.totalMoney,
      desc: '总金额/万元'
    }, {
      num: aggregateSaleData.value.rawMaterialMoney,
      desc: '原料费/万元'
    }, {
      num: aggregateSaleData.value.totalFreight,
      desc: '运费/万元'
    }, {
      num: aggregateSaleData.value.totalSingular,
      desc: '总车次/次'
    }, {
      num: aggregateSaleData.value.totalAveragePrice,
      desc: '总均价/元'
    }];
  });
  var columns = computed(function () {
    return aggregateSaleData.value.settleValueList.map(function (item) {
      return {
        text: item.name,
        value: item.supplier_no
      };
    });
  });
  return [aggregateSaleData, summaryData, columns, getAggregateSaleDataAsync];
}